import { createFileRoute } from '@tanstack/react-router';
import { JourneysPersonAttributesEditRoute } from './-route-wrappers';

/**
 * `/journeys/people/:personId/attributes/edit` — the address the embedded app links the attribute
 * editor at. It forwards to the editor's own URL once the rollout flag is on, and renders the
 * embedded app in place while it is off.
 */
function JourneysPersonAttributesEditFileRoute() {
  const { personId } = Route.useParams();

  return <JourneysPersonAttributesEditRoute personId={personId} />;
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/people/$personId/attributes/edit',
)({
  component: JourneysPersonAttributesEditFileRoute,
});
